/**
 * Поля партий. Имя — собственное название карты, а не «N игроков»: сколько
 * игроков помещается, показывает счетчик в кнопке выбора (playersCount)
 */
export const GAME_FIELDS = [{
  id: 'field_players_2_classic',
  name: 'Теснина',
  path: '/fields/2_players_classic.json',
  playersCount: 2,
}, {
  id: 'field_players_2_alt_4',
  name: 'Хребет',
  path: '/fields/2_players_alt_4.json',
  playersCount: 2,
}, {
  id: 'field_players_2_alt_6',
  name: 'Столица',
  path: '/fields/2_players_alt_6.json',
  playersCount: 2,
}, {
  id: 'field_players_2_alt',
  name: 'Кривой брод',
  path: '/fields/2_players_alt_1.json',
  playersCount: 2,
}, {
  id: 'field_players_2_alt_7',
  name: 'Два стана',
  path: '/fields/2_players_alt_7.json',
  playersCount: 2,
}, {
  id: 'field_players_2_alt_8',
  name: 'Мельница',
  path: '/fields/2_players_alt_8.json',
  playersCount: 2,
}, {
  id: 'field_players_3_classic',
  name: 'Три холма',
  path: '/fields/3_players_classic.json',
  playersCount: 3,
}, {
  id: 'field_players_3_alt_1',
  name: 'Три короны',
  path: '/fields/3_players_alt_1.json',
  playersCount: 3,
}, {
  id: 'field_players_3_alt_2',
  name: 'Ничейные земли',
  path: '/fields/3_players_alt_2.json',
  playersCount: 3,
}, {
  id: 'field_players_3_alt_3',
  name: 'Три долины',
  path: '/fields/3_players_alt_3.json',
  playersCount: 3,
}, {
  id: 'field_players_3_alt_4',
  name: 'Вихрь',
  path: '/fields/3_players_alt_4.json',
  playersCount: 3,
}, {
  id: 'field_players_3_alt_5',
  name: 'Кратер',
  path: '/fields/3_players_alt_5.json',
  playersCount: 3,
}, {
  id: 'field_classic_players_4',
  name: 'Четыре стороны',
  path: '/fields/4_players_classic.json',
  playersCount: 4,
}, {
  id: 'field_players_4_alt_1',
  name: 'Перекресток',
  path: '/fields/4_players_alt_1.json',
  playersCount: 4,
}, {
  id: 'field_players_4_alt_2',
  name: 'Четыре шатра',
  path: '/fields/4_players_alt_2.json',
  playersCount: 4,
}, {
  id: 'field_players_4_alt_3',
  name: 'Золотая жила',
  path: '/fields/4_players_alt_3.json',
  playersCount: 4,
}, {
  id: 'field_players_4_alt_4',
  name: 'Рубеж',
  path: '/fields/4_players_alt_4.json',
  playersCount: 4,
}, {
  id: 'field_classic_players_5',
  name: 'Пять городов',
  path: '/fields/5_players_classic.json',
  playersCount: 5,
}, {
  id: 'field_players_5_alt_1',
  name: 'Пять дорог',
  path: '/fields/5_players_alt_1.json',
  playersCount: 5,
}, {
  id: 'field_players_5_alt_2',
  name: 'Звезда',
  path: '/fields/5_players_alt_2.json',
  playersCount: 5,
}, {
  id: 'field_players_5_alt_3',
  name: 'Венец',
  path: '/fields/5_players_alt_3.json',
  playersCount: 5,
}, {
  id: 'field_classic_players_6',
  name: 'Шесть княжеств',
  path: '/fields/6_players_classic.json',
  playersCount: 6,
}, {
  id: 'field_players_6_alt_1',
  name: 'Шесть ветров',
  path: '/fields/6_players_alt_1.json',
  playersCount: 6,
}, {
  id: 'field_players_6_alt_2',
  name: 'Шестерня',
  path: '/fields/6_players_alt_2.json',
  playersCount: 6,
}, {
  id: 'field_players_6_alt_3',
  name: 'Соты',
  path: '/fields/6_players_alt_3.json',
  playersCount: 6,
}]

// Экспериментальные поля: доступны только на экране выбора поля локальной игры.
// Намеренно НЕ входят в GAME_FIELDS — не участвуют в автовыборе поля сервером
// и в массовых симуляциях ботов (на этих полях может не быть флагов/ключевых точек)
export const EXPERIMENT_GAME_FIELDS = [{
  id: 'field_europe',
  name: 'Европа (эксперимент)',
  path: '/fields/europe.json',
  playersCount: 6,
}, {
  id: 'field_players_2_alt_2',
  name: 'Перешеек (эксперимент)',
  path: '/fields/2_players_alt_2.json',
  playersCount: 2,
}, {
  id: 'field_players_2_alt_3',
  name: 'Два озера (эксперимент)',
  path: '/fields/2_players_alt_3.json',
  playersCount: 2,
}, {
  id: 'field_players_2_alt_5',
  name: 'Два лагеря (эксперимент)',
  path: '/fields/2_players_alt_5.json',
  playersCount: 2,
}]

export const DEFAULT_GAME_FIELD = {
  id: 'field_test',
  name: 'Тестовое поле',
  path: '/other/default-ahex-game-state.json'
}

export const EMPTY_GAME_FIELD = {
  id: 'field_empty',
  name: 'Пустое поле',
}